import { CuffaAPI } from 'api/cuffa/cuffa.api';
import { ROUTES } from 'routes/constants';
import { CuffaProductTypeEnum, CuffaManagementTypeEnum } from 'common/enums';

export function buildProductsPayload(values: any) {
  const productsPayload = values.selectedProducts.map((product: any) => ({
    productId: product.product_type === CuffaProductTypeEnum.PADRAO ? product.uuid ?? product.id : undefined,
    name: product.product_type === CuffaProductTypeEnum.CUSTOMIZADO ? product.name : undefined,
    product_type: product.product_type,
    production_type: product.production_type,
    management_type: values.managementType as CuffaManagementTypeEnum,
    is_processed: product.is_processed,
    produced_quantity: product.quantity,
    measurement_unit: product.unit,

    area_hectares: values.area_hectares ? Number(values.area_hectares) : undefined,
    volume_produced: values.volume_produced ? Number(values.volume_produced) : undefined,
    volume_commercialized: values.volume_commercialized ? Number(values.volume_commercialized) : undefined,
    commercialized_value: values.commercialized_value ?
      Number(values.commercialized_value.replace(/\D/g, '')) / 100 : undefined,
    volume_consumed_donated: values.volume_consumed_donated ? Number(values.volume_consumed_donated) : undefined,
    volume_lost: values.volume_lost ? Number(values.volume_lost) : undefined,

    availability_months: values.availability_months,

    has_certification: typeof values.has_certification === 'boolean' ? values.has_certification : undefined,
    certification_type: values.has_certification === true
      ? (values.certification_type || undefined)
      : undefined,
    other_certification_name: values.has_certification === true
      ? (values.other_certification_name || undefined)
      : undefined,
  }));

  return { products: productsPayload };
}

export function createHandleSubmit({ uuid, navigate, setSnackbarMessage, setSnackbarError, setOpenSnackbar, setSaving, setLoadingState }: any) {
  return async function handleSubmit(values: any) {
    if (!uuid) {
      setSnackbarMessage("UUID da coleta não encontrado na URL.");
      setSnackbarError(true);
      setOpenSnackbar(true);
      setSaving(false);
      setLoadingState(null);
      return;
    }

    setSaving(true);

    try {
      const payload = buildProductsPayload(values);
      await CuffaAPI.updateProducts(uuid, payload);

      setSnackbarMessage('Produtos enviados com sucesso!');
      setSnackbarError(false);
      setOpenSnackbar(true);

      if (setLoadingState && setLoadingState === 'avancar') {
        // no-op: preserve original behavior when caller inspects loadingState
      }
    } catch (error: any) {
      console.error('Erro ao enviar dados:', error);
      setSnackbarMessage(error?.message || 'Erro ao enviar dados.');
      setSnackbarError(true);
      setOpenSnackbar(true);
    } finally {
      setSaving(false);
      setLoadingState(null);
    }
  };
}

export default createHandleSubmit;
